module.exports = __webpack_public_path__ + "static/media/treenutfree.f673cbd4.jpg";